export { normalizeUrlArgument };
import { assertUsage, isUrl, isUrlRelative } from './utils.js';
function normalizeUrlArgument(url, fnName) {
    // Succinct error message to save client-side KBs
    const errMsg = `[${fnName}(url)] Invalid URL ${url}`;
    assertUsage(isUrl(url), errMsg);
    if (url.startsWith(location.origin)) {
        // Use normalizeClientSideUrl() instead?
        url = url.slice(location.origin.length);
    }
    assertUsage(url.startsWith('/') || isUrlRelative(url), 
    // `errMsg` used the original `url` value
    errMsg);
    return url;
}
